import { render, staticRenderFns } from "./SmartListsTop.vue?vue&type=template&id=bce70350"
import script from "./SmartListsTop.vue?vue&type=script&lang=js"
export * from "./SmartListsTop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports